<template>
  <div>
    <ul :class="{'tree' : root}">
      <li v-if="root">
        <span @click="setId({'id': root.id, 'root': true})" :class="{'selected': isSelected(root.id)}">{{ root.question
          }}</span>
        <tree :children="root.children" />
      </li>
      <li v-else v-for="child in children" v-bind:key="child.id">
        <span @click="setId({'id': child.id, 'root': false})"
              :class="{'selected': isSelected(child.id)}">{{ child.question }}</span>
        <tree v-if="child.children && child.children.length > 0" :children="child.children" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "tree",
  props: {
    children: Array,
    root: Object
  },
  data() {
    return {
      isOpenContextMenu: false
    };
  },
  methods: {
    ...mapActions(["setId", "showActionMenu", "closeActionMenu"]),
    openMenu(event, payload) {
      this.setId(payload);
      this.showActionMenu({ "xPos": event.pageX, "yPos": event.pageY });
    },
    isSelected(questionId) {
      return this.selectedId === questionId;
    }
  },
  computed: {
    ...mapGetters(["selectedId"])
  }
};
</script>

<style scoped>

span.selected {
  background-color: blue;
  color:white;
}

/* below the css needed to create a tree */
.tree, .tree ul, .tree li {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.tree {
  margin: 0 0 1em;
  text-align: center;
}

.tree, .tree ul {
  display: table;
}

.tree ul {
  width: 100%;
}

.tree li {
  display: table-cell;
  padding: .5em 0;
  vertical-align: top;
}

/* _________ */
.tree li:before {
  outline: solid 1px #666;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.tree li:first-child:before {
  left: 50%;
}

.tree li:last-child:before {
  right: 50%;
}

.tree code, .tree span {
  border: solid .1em #666;
  border-radius: .2em;
  display: inline-block;
  margin: 0 .2em .5em;
  padding: .2em .5em;
  position: relative;
}

/* If the tree represents DOM structure */
.tree code {
  font-family: monaco, Consolas, 'Lucida Console', monospace;
}

/* | */
.tree ul:before,
.tree code:before,
.tree span:before {
  outline: solid 1px #666;
  content: "";
  height: .5em;
  left: 50%;
  position: absolute;
}

.tree ul:before {
  top: -.5em;
}

.tree code:before,
.tree span:before {
  top: -.55em;
}

/* The root node doesn't connect upwards */
.tree > li {
  margin-top: 0;
}

.tree > li:before,
.tree > li:after,
.tree > li > code:before,
.tree > li > span:before {
  outline: none;
}
</style>